import React, { useState, useEffect, useReducer } from 'react'
import { Table, Icon, Panel, Row, Col, Button, ButtonToolbar } from 'rsuite' // เพิ่ม Col, Button, ButtonToolbar
import { useHistory } from 'react-router-dom'
import EditButton from '../../components/buttons/editButton/EditButton'
import { maskIdCard } from '../../utils/dataUtil'
import { searchCreatePayeeAndTax } from '../../redux/actions/createPayeeAndTax'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'

export default function CreatePayeeAndTaxInfoTable({
  schema: _schema,
  loading,
  onSelect,
  isViewMode,
  searchSchema,
  projectCode, // เพิ่ม projectCode ให้เรียกใช้ใน handleGet ได้
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [tableDataB, setTableDataB] = useState([])
  const [isExpandedTop, setIsExpandedTop] = useState(true)
  const [isExpandedBottom, setIsExpandedBottom] = useState(true)
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const styleMainHeader = { paddingTop: '1%', paddingBottom: '1%' }

  // เพิ่ม State สำหรับ Input (ตามที่คุณเขียนค้างไว้ใน handleGet)
  const [searchTax, setSearchTax] = useState('')
  const [searchName, setSearchName] = useState('')
  const [searchEmail, setSearchEmail] = useState('')
  const [searchPhone, setSearchPhone] = useState('')

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  // Function สำหรับแยกประเภทข้อมูล (ใช้ซ้ำได้ทั้งตอนโหลดหน้าและตอนค้นหา)
  const splitData = (data) => {
    let newArr = [],
      newArr2 = []
    data.map((item) => {
      if (item.registerType != '9') {
        newArr.push(item)
      } else {
        newArr2.push(item)
      }
    })
    console.log('arr1', newArr)
    console.log('arr2', newArr2)
    setTableData(newArr)
    setTableDataB(newArr2)
  }


  useEffect(() => {
    if (_schema && _schema.length > 0) {
      splitData(_schema)
    }
  }, [_schema])

// 2. ฟังก์ชันดึงข้อมูลจากหลังบ้าน (API)
  const fetchSearchData = async (criteria = {}) => {
    const { taxId = '', name = '', email = '', phoneNumber = '' } = criteria

    // --- 1. เตรียมข้อมูล และกรองเอาเฉพาะฟิลด์ที่ผู้ใช้พิมพ์จริงๆ (ลบค่าว่างทิ้งเพื่อป้องกัน API Error) ---
    const rawRequest = {
      taxId,
      name,
      email,
      phoneNumber,
    };

    // ตัวแปร request จะเหลือแค่ค่าที่ถูกกรอกเท่านั้น เช่น ถ้ากรอกแค่ taxId ก็จะส่งไปแค่ { taxId: '1536' }
    const request = Object.keys(rawRequest).reduce((acc, key) => {
      if (rawRequest[key] !== undefined && rawRequest[key] !== null && rawRequest[key] !== '') {
        acc[key] = rawRequest[key];
      }
      return acc;
    }, {});

    try {
      if (  projectCode) {
        const response = await searchCreatePayeeAndTax(projectCode, request);
      splitData(response.forms.valus||[])
      } else {
        console.error("Missing API function or projectCode");
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  }

  const handleGet = async () => {
    await fetchSearchData({
      taxId: searchTax,
      name: searchName,
      email: searchEmail,
      phoneNumber: searchPhone,
    })
  }

  // ฟังก์ชันสำหรับปุ่มยกเลิก/ล้างข้อมูล
  const handleReset = async () => {
    setSearchTax('')
    setSearchName('')
    setSearchEmail('')
    setSearchPhone('')
    await fetchSearchData()
  }

  return (
    <>
      <Panel
        bordered
        collapsible
        defaultExpanded
        header={'ผู้รับเงินและข้อมูลภาษีทั่วไป'}
        expanded={isExpandedTop}
        onSelect={() => {
          setIsExpandedTop(!isExpandedTop)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        
        {/* ส่วนการค้นหาที่เพิ่มปุ่มเข้าไป */}
        <Row style={{ marginBottom: 20, padding: '0 10px' }}>
            <Col lg={6} md={12} sm={24} xs={24}>
            <label>{searchSchema?.searchTax?.label}</label>
            <input
              className="rs-input"
              style={{ width: '100%' }}
              value={searchTax}
              placeholder={searchSchema?.searchTax?.placeholder}
              onChange={(e) => setSearchTax(e.target.value)}
            />
          </Col>
            <Col lg={6} md={12} sm={24} xs={24}>
            <label>{searchSchema?.searchName?.label}</label>
            <input
              className="rs-input"
              style={{ width: '100%' }}
              value={searchName}
              placeholder={searchSchema?.searchName?.placeholder}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </Col>
            <Col lg={6} md={12} sm={24} xs={24}>
            <label>{searchSchema?.searchEmail?.label}</label>
            <input
              className="rs-input"
              style={{ width: '100%' }}
              value={searchEmail}
              placeholder={searchSchema?.searchEmail?.placeholder}
              onChange={(e) => setSearchEmail(e.target.value)}
            />
          </Col>
            <Col lg={6} md={12} sm={24} xs={24}>
        <label>{searchSchema?.searchPhoneNumber?.label}</label>
            <input
              className="rs-input"
              style={{ width: '100%' }}
              value={searchPhone}
            placeholder={searchSchema?.searchPhoneNumber?.placeholder} 
              onChange={(e) => setSearchPhone(e.target.value)}
            />
          </Col>
        </Row>

         <Row>
            <ButtonToolbar>

              <SaveButton onClick={handleGet} icon="search">
                ค้นหา
              </SaveButton>
              <CancelButton onClick={handleReset} icon="close">
                ยกเลิก
              </CancelButton>
            </ButtonToolbar>
          </Row>

        <Table wordWrap height={400} headerHeight={80} loading={loading} data={tableData}>
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>เลขที่ผู้เสียภาษี</HeaderCell>
            <Cell>
              {(rowData) => {
                return <>{maskIdCard(rowData.tax)}</>
              }}
            </Cell>
          </Column>

          <Column width={250}>
            <HeaderCell>ชื่อ</HeaderCell>
            <Cell dataKey="fullName" />
          </Column>

          <Column width={250} minWidth={280} flexGrow={1}>
            <HeaderCell>ที่อยู่</HeaderCell>
            <Cell dataKey="address" />
          </Column>

          <Column width={180}>
            <HeaderCell>อีเมล์</HeaderCell>
            <Cell dataKey="email" />
          </Column>

          <Column width={180}>
            <HeaderCell>เบอร์โทรศัพท์ติดต่อ</HeaderCell>
            <Cell dataKey="phoneNumber" />
          </Column>

          <Column width={170}>
            <HeaderCell>
              <div style={styleHeaderCell}>ให้หัก ณ.ที่จ่ายนำส่ง</div>
            </HeaderCell>
            <Cell align="center">
              {(rowData) => {
                if (rowData.withholding) {
                  return <Icon icon="check-circle" size="lg" style={{ color: '#2da888' }} />
                } else {
                  return <Icon icon="minus-circle" size="2x" style={{ color: '#8080808a' }} />
                }
              }}
            </Cell>
          </Column>

          <Column width={150}>
            <HeaderCell>
              <div style={styleHeaderCell}>จดภาษีมูลค่าเพิ่ม</div>
            </HeaderCell>
            <Cell align="center">
              {(rowData) => {
                if (rowData.vatRegister) {
                  return <Icon icon="check-circle" size="lg" style={{ color: '#2da888' }} />
                } else {
                  return <Icon icon="minus-circle" size="2x" style={{ color: '#8080808a' }} />
                }
              }}
            </Cell>
          </Column>

          {!isViewMode && (
            <Column width={120} align="center" fixed="right">
              <HeaderCell>จัดการ</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <EditButton
                        onClick={() => {
                          onSelect(rowData)
                        }}
                        disabled={!rowData.isEditabled}
                      >
                        แก้ไข
                      </EditButton>
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </Panel>

      <br />
      <Panel
        bordered
        collapsible
        defaultExpanded
        header={'รายการผู้รับเงิน อื่นๆ '}
        expanded={isExpandedBottom}
        onSelect={() => {
          setIsExpandedBottom(!isExpandedBottom)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <Table wordWrap headerHeight={80} height={400} loading={loading} data={tableDataB}>
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>เลขรหัสกำกับ</HeaderCell>
            <Cell dataKey="tax" />
          </Column>

          <Column width={250}>
            <HeaderCell>ชื่อรายการ</HeaderCell>
            <Cell dataKey="fullName" />
          </Column>

          <Column width={250} minWidth={280} flexGrow={1}>
            <HeaderCell>คำอธิบายรายการ</HeaderCell>
            <Cell dataKey="address" />
          </Column>

          <Column width={170}>
            <HeaderCell align="center">ให้หัก ณ.ที่จ่ายนำส่ง</HeaderCell>
            <Cell align="center">
              {(rowData) => {
                if (rowData.withholding) {
                  return <Icon icon="check-circle" size="lg" style={{ color: '#2da888' }} />
                } else {
                  return <Icon icon="minus-circle" size="2x" style={{ color: '#8080808a' }} />
                }
              }}
            </Cell>
          </Column>

          <Column width={150}>
            <HeaderCell align="center">จดภาษีมูลค่าเพิ่ม</HeaderCell>
            <Cell align="center">
              {(rowData) => {
                if (rowData.vatRegister) {
                  return <Icon icon="check-circle" size="lg" style={{ color: '#2da888' }} />
                } else {
                  return <Icon icon="minus-circle" size="2x" style={{ color: '#8080808a' }} />
                }
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  )
}
